export { default } from './components/Data2';
export * from './modules/actions';
export * from './modules/reducer';
